import React, { useState, useEffect, forwardRef, useImperativeHandle, useContext } from "react";
import Table from "../../../../Components/UiComponents/Table/Table";
import {
  XCircleblack,
} from "../../../../Components/IconComponents";
import { facilityTableData } from "../../../../JsonData/CreateFacilityConfig";
import {
  postDataWithBody,
} from "../../../../Services/Services";
import {
  getMyTaskListURL,
  completeNotificationSop,
  completeMytask,
} from "../../../../Services/EndPoints";
import Moment from "react-moment";
import { toast } from "react-toastify";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import TaskModalWithCommentSop from "../../../../Components/UiComponents/TaskModalWithComment/TaskModalWithCommentSop";

import { ThemeContext } from "../../../..";

const MyTaskList = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [taskData, setTaskData] = useState(null);
  const [showPop, setShowPop] = React.useState(false);
  const [rowCount, setRowCount] = useState(0);
  const { theme } = useContext(ThemeContext);

  const { keycloak } = useKeycloak();

  useEffect(() => {
    setTimeout(function () {
      getMyTaskList();
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let taskServiceData = [];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getMyTaskList = async () => {
    var myTaskList = await postDataWithBody(
      getMyTaskListURL,
      { user_name: getLoggedInuserName() },
      {}
    );
    taskServiceData = myTaskList;
    setRowCount(myTaskList.length);
    setData(myTaskList);
  };



  const getLoggedInuserName = () => {
    return keycloak.idTokenParsed.email;
  };



  const showCompleteTaskPopup = (elem) => {
    setTaskData(elem);
    setShowPop(!showPop);
  };

  function refreshTaskTable() {
    getMyTaskList();
    setShowPop(false);
  }

  // Expose the refresh function to parent component
  useImperativeHandle(ref, () => ({
    refreshSopList: () => {
      getMyTaskList();
    }
  }));

  const columns = React.useMemo(
    () => [
      {
        Header: t("soprelatedtasktableheaders.taskname"),
        accessor: "task_name",
        disableSortBy: true,
      },
      {
        Header: t("soprelatedtasktableheaders.description"),
        accessor: "description",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullDescription, setFullDescription] = useState("");
          const [highlightedDescription, setHighlightedDescription] =
            useState(""); // New state for highlighted description

          const handleShowModal = (description) => {
            setFullDescription(description);
            setHighlightedDescription(description); // Set the description being viewed to highlight...
            setShowModal(true);
          };

          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedDescription(""); // Reset the highlighted description when the modal is closed
          };

          const descriptionText = props.value || "NA";
          const truncatedDescription =
            descriptionText.length > 25
              ? `${descriptionText.substring(0, 25)}...`
              : descriptionText;

          // Apply background color if the description is currently being viewed in the modal
          const isHighlighted = descriptionText === highlightedDescription;
          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector(".modal-content");
              el.style.cssText =
                "background-color: #1c2038 !important; border-radius: 20px !important;";
            }, 0);
          }

          return (
            <span>
              <span
                title={descriptionText} // Tooltip with full description on hover
                style={{
                  cursor: "pointer", // Added pointer cursor to indicate clickability
                  backgroundColor: isHighlighted ? "#18A3A0" : "transparent", // Highlight background when viewed
                  padding: "2px 5px", // Add padding to give a little space around the text
                  borderRadius: "5px", // Rounded corners for the highlighted background
                }}
                onClick={() => handleShowModal(descriptionText)} // Open the modal with full description
              >
                {truncatedDescription}
              </span>

              {/* Modal to display the full description */}
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: "20px", // Smooth rounded edges
                  border: "none", // Remove border to avoid white edges
                  top: "20%",
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : "#1c2038", // Dark blue background for header
                    color: "white", // White text in the header
                    borderBottom: "none", // Remove bottom border to prevent white edges
                  }}
                >
                  <Modal.Title style={{ color: "white" }}>
                    Full Description
                  </Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48", // Blue background for body
                    color: theme === "light" ? "#001b30" : "white", // White text in the body
                    border: "none", // Remove border to prevent white edges
                    borderRadius: "0px", // Remove radius to make it seamless
                    padding: "20px", // Added padding for spacing
                    lineHeight: "1.8",
                  }}
                >
                  <p>{fullDescription}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48", // Darker blue footer
                    color: "white", // White text in footer
                    borderTop: "none", // Remove top border to prevent white edges
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: theme === "light" ? "#2b6591" : "#252b48", // Dark blue button
                      borderColor: "#003366", // Dark border for button
                      borderRadius: "5px", // Rounded button edges
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        },
      },
      {
        Header: t("soprelatedtasktableheaders.actionmessage"),
        accessor: "action_message",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [fullMessage, setFullMessage] = useState("");
          const [highlightedMessage, setHighlightedMessage] = useState(""); // New state for highlighted message

          const handleShowModal = (message) => {
            setFullMessage(message);
            setHighlightedMessage(message); // Highlight the message being viewed
            setShowModal(true);
          };

          const handleCloseModal = () => {
            setShowModal(false);
            setHighlightedMessage(""); // Reset highlighted message when modal closes
          };

          const messageText = props.value || "NA";
          const truncatedMessage =
            messageText.length > 25 ? `${messageText.substring(0, 25)}...` : messageText;

          const isHighlighted = messageText === highlightedMessage;

          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector(".modal-content");
              el.style.cssText =
                "background-color: #1c2038 !important; border-radius: 20px !important;";
            }, 0);
          }

          return (
            <span>
              <span
                title={messageText} // Tooltip with full message on hover
                style={{
                  cursor: "pointer", // Pointer cursor to indicate clickability
                  backgroundColor: isHighlighted ? "#18A3A0" : "transparent", // Highlight background when viewed
                  padding: "2px 5px",
                  borderRadius: "5px",
                }}
                onClick={() => handleShowModal(messageText)} // Open the modal with full message
              >
                {truncatedMessage}
              </span>

              {/* Modal to display the full action message */}
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                style={{
                  borderRadius: "20px",
                  border: "none",
                  top: "20%",
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : "#1c2038",
                    color: "white",
                    borderBottom: "none",
                  }}
                >
                  <Modal.Title style={{ color: "white" }}>Full Action Message</Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48", // Blue background for body
                    color: theme === "light" ? "#001b30" : "white",
                    border: "none",
                    padding: "20px",
                    lineHeight: "1.8",
                  }}
                >
                  <p>{fullMessage}</p>
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
                    color: "white",
                    borderTop: "none",
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: theme === "light" ? "#2b6591" : "#252b48",
                      borderColor: "#003366",
                      borderRadius: "5px",
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </span>
          );
        },
      },
      // {
      //   Header: t("soprelatedtasktableheaders.tasktype"),
      //   accessor: "task_type",
      //   disableSortBy: true,
      // },
      {
        Header: t("soprelatedtasktableheaders.createdby"),
        accessor: "created_by",
        disableSortBy: true,
      },
      {
        Header: t("soprelatedtasktableheaders.createdon"),
        accessor: "created_on",
        Cell: (props) => {
          if (props.value) {
            const gmtOffsetValue = new Date(props.value);
            // gmtOffsetValue.setMinutes(gmtOffsetValue.getMinutes() + 330); // Add 5:30 offset (330 minutes)
            return (
              <Moment format="DD/MM/YYYY, hh:mm a">{gmtOffsetValue}</Moment>
            );
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("soprelatedtasktableheaders.updatedon"),
        accessor: "updated_on",
        Cell: (props) => {
          if (props.value) {
            const gmtOffsetValue = new Date(props.value);
            // gmtOffsetValue.setMinutes(gmtOffsetValue.getMinutes() + 330); // Add 5:30 offset (330 minutes)
            return (
              <Moment format="DD/MM/YYYY, hh:mm a">{gmtOffsetValue}</Moment>
            );
          } else {
            return "NA";
          }
        },
        disableSortBy: true,
      },
      {
        Header: t("soprelatedtasktableheaders.Viewimage"),
        accessor: "uploaded_images",
        disableSortBy: true,
        Cell: (props) => {
          const [showModal, setShowModal] = useState(false);
          const [imageUrls, setImageUrls] = useState([]);
          const [loadingStates, setLoadingStates] = useState({});

          const handleShowModal = (imagesString, taskFileName) => {
            try {
              let allImages = [];

              // Parse uploaded_images JSON string
              if (imagesString) {
                const parsedImages = JSON.parse(imagesString);
                if (Array.isArray(parsedImages) && parsedImages.length > 0) {
                  allImages = [...parsedImages];
                }
              }

              // Add task_file_name if it exists
              if (taskFileName && taskFileName.trim() !== "") {
                allImages.push(taskFileName);
              }

              // Check if there are any images to display
              if (allImages.length === 0) {
                toast.info("No images available", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                return;
              }

              setImageUrls(allImages);

              // Initialize loading states for all images
              const initialLoadingStates = {};
              allImages.forEach((_, index) => {
                initialLoadingStates[index] = true;
              });
              setLoadingStates(initialLoadingStates);
              setShowModal(true);
            } catch (error) {
              console.error("Error parsing images:", error);
              toast.error("Unable to load images", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            }
          };

          const handleCloseModal = () => {
            setShowModal(false);
            setImageUrls([]);
            setLoadingStates({});
          };

          const handleImageLoad = (index) => {
            setLoadingStates(prev => ({
              ...prev,
              [index]: false
            }));
          };

          const handleImageError = (index, e) => {
            setLoadingStates(prev => ({
              ...prev,
              [index]: false
            }));
            e.target.style.display = "none";
            const errorDiv = e.target.parentElement.querySelector('.error-message');
            if (errorDiv) {
              errorDiv.style.display = "block";
            }
          };

          // Check if there are any images to display
          const hasUploadedImages = props.value && props.value !== "[]" && props.value !== "";
          const hasTaskFile = props.row.original.task_file_name && props.row.original.task_file_name.trim() !== "";
          const hasAnyImages = hasUploadedImages || hasTaskFile;

          if (!hasAnyImages) {
            return <span style={{ color: "#999" }}>NA</span>;
          }

          if (showModal) {
            setTimeout(() => {
              let el = document.querySelector(".modal-content");
              if (el) {
                el.style.cssText =
                  "background-color: #1c2038 !important; border-radius: 20px !important;";
              }
            }, 0);
          }

          return (
            <span>
              <i
                className="fa fa-eye"
                style={{
                  cursor: "pointer",
                  color: "#18A3A0",
                  fontSize: "1.2em",
                }}
                onClick={() => handleShowModal(props.value, props.row.original.task_file_name)}
                title="View Images"
              ></i>

              {/* Modal to display all images */}
              <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-modal"
                centered
                size="lg"
                style={{
                  borderRadius: "20px",
                  border: "none",
                  top: "5%",
                }}
              >
                <Modal.Header
                  style={{
                    backgroundColor: theme === "light" ? "#2b6591" : "#1c2038",
                    color: "white",
                    borderBottom: "none",
                  }}
                >
                  <Modal.Title style={{ color: "white" }}>
                    View Attachments ({imageUrls.length})
                  </Modal.Title>
                  <XCircleblack
                    onClick={handleCloseModal}
                    width="1.5em"
                    height="1.5em"
                    className="cursor-pointer"
                  />
                </Modal.Header>
                <Modal.Body
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
                    color: theme === "light" ? "#001b30" : "white",
                    border: "none",
                    padding: "15px",
                    maxHeight: "70vh",
                    overflowY: "auto",
                  }}
                >
                  {imageUrls.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                        gap: "15px",
                      }}
                    >
                      {imageUrls.map((url, index) => (
                        <div
                          key={index}
                          style={{
                            border: "2px solid #ddd",
                            borderRadius: "8px",
                            overflow: "hidden",
                            backgroundColor: "#f8f9fa",
                            position: "relative",
                            height: "300px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/* Image Label */}
                          {/* <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              left: "5px",
                              backgroundColor: "rgba(0, 0, 0, 0.6)",
                              color: "white",
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              zIndex: 2,
                            }}
                          >
                            Image {index + 1}
                          </div> */}

                          {/* Loading Spinner */}
                          {loadingStates[index] && (
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 1,
                              }}
                            >
                              <div
                                style={{
                                  border: "4px solid #f3f3f3",
                                  borderTop: "4px solid #18A3A0",
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                  animation: "spin 1s linear infinite",
                                }}
                              ></div>
                            </div>
                          )}

                          <img
                            src={url}
                            alt={`Attachment ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              display: loadingStates[index] ? "none" : "block",
                              padding: "5px",
                            }}
                            onLoad={() => handleImageLoad(index)}
                            onError={(e) => handleImageError(index, e)}
                          />

                          {/* Error message */}
                          <div
                            className="error-message"
                            style={{
                              display: "none",
                              padding: "20px",
                              textAlign: "center",
                              color: "#dc3545",
                              fontSize: "14px",
                            }}
                          >
                            <i className="fa fa-exclamation-triangle" style={{ fontSize: "24px", marginBottom: "10px" }}></i>
                            <br />
                            Failed to load image
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ textAlign: "center" }}>No images available</p>
                  )}
                </Modal.Body>
                <Modal.Footer
                  style={{
                    backgroundColor: theme === "light" ? "#fcfcfc" : "#252b48",
                    color: "white",
                    borderTop: "none",
                  }}
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    style={{
                      backgroundColor: theme === "light" ? "#2b6591" : "#252b48",
                      borderColor: "#003366",
                      borderRadius: "5px",
                      marginBottom: '30px'
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Add CSS for spinner animation */}
              <style>
                {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
              </style>
            </span>
          );
        },
      },
      {
        Header: t("dailyoperationaltasktableheaders.status"),
        accessor: "task_status_code",
        disableSortBy: true,
        Cell: (props) => {
          // Use the original task status directly from the row data
          // This ensures we always display the actual database value
          const originalStatus = props.row.original.task_status_code;
          const [showConfirmPopup, setShowConfirmPopup] = useState(false);
          const [showActivityConfirmPopup, setShowActivityConfirmPopup] =
            useState(false);

          const toggleConfirmPopup = () => {
            setShowConfirmPopup(!showConfirmPopup);
          };

          const toggleActivityConfirmPopup = () => {
            setShowActivityConfirmPopup(!showActivityConfirmPopup);
          };

          const handleStatusChange = (newStatus) => {
            const { task_type } = props.row.original;

            if (newStatus === "TASK_EXE_STATUS_INPROGRESS") {
              if (task_type === "Activity") {
                showCompleteTaskPopup(props.row.original);
              } else {
                toggleConfirmPopup();
              }
            } else if (newStatus === "TASK_EXE_STATUS_COMPLETED") {
              if (task_type === "Notification") {
                toggleConfirmPopup();
              } else {
                showCompleteTaskPopup(props.row.original);
              }
            }
          };
          console.log(props, "propspropsprops");
          const confirmTaskById = async (id, task_id) => {
            let input = {
              sop_instance_id: id,
              // sop_instance_id: props.taskData.id,
              task_id: task_id,
              user_name: getLoggedInuserName(),
            };
            var res = await postDataWithBody(
              completeNotificationSop,
              input,
              {}
            );
            if (res.status === "success") {
              getMyTaskList(); // Refresh the full table
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            toggleConfirmPopup();
          };

          const todayDate = new Date().toISOString().split("T")[0];

          const confirmTaskByIdActivity = async (id) => {
            let input = {
              id: id,
              taskCompletedDate: todayDate,
            };
            var res = await postDataWithBody(completeMytask, input, {});
            if (res.status === "success") {
              getMyTaskList(); // Refresh the full table
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            toggleActivityConfirmPopup();
          };

          const getDropdownColor = (status) => {
            switch (status) {
              case "TASK_EXE_STATUS_NEW_TASK":
                return "#0074ba";
              case "TASK_EXE_STATUS_INPROGRESS":
                return "#ffaa22";
              case "TASK_EXE_STATUS_COMPLETED":
                return "#13845d";
              case "TASK_EXE_STATUS_CANCEL":
                return "Red";
              case "TASK_EXE_STATUS_CLOSED":
                return "Red";
              default:
                return "gray";
            }
          };

          // Conditionally render dropdown or message
          if (originalStatus === "TASK_EXE_STATUS_CANCEL") {
            return (
              <div className="startedbysomeoneNew">
                <div>{t("cancelled")}</div>
              </div>
            );
          }

          if (originalStatus === "TASK_EXE_STATUS_CLOSED") {
            return (
              <div className="startedbysomeoneNews">
                <div>{t("Closed")}</div>
              </div>
            );
          }


          return (
            <div>
              <select
                value={originalStatus} // Always use the original status from props
                onChange={(e) => handleStatusChange(e.target.value)}
                style={{
                  padding: "5px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  backgroundColor: getDropdownColor(originalStatus),
                  color: "white",
                  width: "120px",
                }}
              >
                <option
                  value="TASK_EXE_STATUS_NEW_TASK"
                  disabled={originalStatus !== "TASK_EXE_STATUS_NEW_TASK"}
                >
                  {props.row.original.task_type === "Notification"
                    ? t("New Message")
                    : t("Started")}
                </option>

                {props.row.original.task_type !== "Notification" && (
                  <option
                    value="TASK_EXE_STATUS_INPROGRESS"
                    disabled={originalStatus === "TASK_EXE_STATUS_COMPLETED"}
                  >
                    {t("In Progress")}
                  </option>
                )}

                <option
                  value="TASK_EXE_STATUS_COMPLETED"
                  disabled={
                    props.row.original.task_type === "Notification"
                      ? originalStatus !== "TASK_EXE_STATUS_NEW_TASK"
                      : originalStatus !== "TASK_EXE_STATUS_INPROGRESS"
                  }
                >
                  {props.row.original.task_type === "Notification"
                    ? t("Acknowledged")
                    : t("Completed")}
                </option>
              </select>

              {showConfirmPopup && (
                <Confirmpopup
                  className="DeltePopup"
                  show={showConfirmPopup}
                  title={t("acknowldgtask")}
                  message={t("popupmsg")}
                  handleToggle={toggleConfirmPopup}
                  row={props.row}
                  name={props.row.original.task_name}
                  deleteRow={() => confirmTaskById(props.row.original.sop_instance_id, props.row.original.task_id)}
                  cancel={t("cancelbutton")}
                  action={t("confirm")}
                />
              )}

              {showActivityConfirmPopup && (
                <Confirmpopup
                  className="DeltePopup"
                  show={showActivityConfirmPopup}
                  title={t("acknowldgtask")}
                  message={"Are you sure you want to complete the task?"}
                  handleToggle={toggleActivityConfirmPopup}
                  row={props.row}
                  name={props.row.original.task_name}
                  deleteRow={() =>
                    confirmTaskByIdActivity(props.row.original.id)
                  }
                  cancel={t("cancelbutton")}
                  action={t("confirm")}
                />
              )}
            </div>
          );
        },
      },
      {
        Header: t("soprelatedtasktableheaders.priority"),
        accessor: "priority",
        disableSortBy: true,
        Cell: ({ value }) => {
          const priorityMap = {
            0: { color: "#0166FF", label: t("Low") }, // Green
            1: { color: "#ffc107", label: t("Medium") }, // Yellow
            2: { color: "#dc3545", label: t("High") }, // Red
          };

          const priority = priorityMap[value] || priorityMap[0]; // Default to "Low"

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  backgroundColor: priority.color,
                  borderRadius: "50%",
                  display: "inline-block",
                }}
              ></span>
              <span style={{ color: "inherit" }}>{priority.label}</span>{" "}
              {/* Text remains default color */}
            </div>
          );
        },
      },
      {
        Header: t("soprelatedtasktableheaders.cancelreason"),
        accessor: "cancel_reason",
        disableSortBy: true,
        Cell: ({ value }) => value || "NA"
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  );

  return (
    <div className="my-task-list-table">
      <style>{`
        .my-task-list-table tbody tr td,
        .my-task-list-table tbody tr th {
          border: none !important;
        }
        .my-task-list-table tbody tr td {
          background-color: #fff !important;
          color: #1D2939 !important;
        }
        .my-task-list-table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
      `}</style>
      {showPop && (
        <TaskModalWithCommentSop
          titleValue={t("actiontaken")}
          showSuccessMsg={refreshTaskTable}
          taskData={taskData}
          show={showPop}
          buttonLabel={t("popup.save")}
          handleToggle={showCompleteTaskPopup}
          getMyTaskList={getMyTaskList}
          setShowPop={setShowPop}
          {...props}
        />
      )}

      {facilityTableData && (
        <Table
          data={data}
          title=""
          columns={columns}
          numberOfRows={7}
          showExport={false}
          showReset={false}
          onExpand={false}
          showSearch={true}
          isHeaderFixed={true}
          rowCount={rowCount}
          headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
          tableStyle={{
            border: "1px solid  #f0f0f0",
            padding: "2px",
            borderRadius: "12px",
          }}
        />
      )}
    </div>
  );
});

export default MyTaskList;